import React, { useState } from 'react';
// Import only specific icons used
import { FaCommentDots, FaChevronDown } from 'react-icons/fa';
import '../LandingPage.css'; // Assuming styles are still here or adjust path if needed

function ChatWidget() {
  // State for chat widget visibility
  const [isChatOpen, setIsChatOpen] = useState(false);

  // Function to toggle chat widget visibility
  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  // Hardcoded chat URL as per PRD
  const chatUrl = "/chat/55956052-c400-46f0-9234-6265b7bfdd6b";

  return (
    <>
      {/* Chat Icon Button */}
      <button
        className={`chat-widget-icon ${isChatOpen ? 'chat-widget-icon--hidden' : ''}`}
        onClick={toggleChat}
        aria-label="Open chat"
        title="Open chat"
        aria-expanded={isChatOpen} // Indicate expanded state
        disabled={isChatOpen} // Disable when chat is open to prevent interaction
      >
        {/* Use direct import */}
        <FaCommentDots size={24} />
      </button>

      {/* Chat Window */}
      <div
        className={`chat-widget-window ${!isChatOpen ? 'chat-widget-window--hidden' : ''}`}
        role="dialog"
        aria-modal="true" // It still functions like a modal dialog when visible
        aria-labelledby="chat-widget-header"
        aria-hidden={!isChatOpen} // Indicate visibility state for screen readers
      >
        <div className="chat-widget-header" id="chat-widget-header">
          <span>Chat with EFSoft</span>
          <button
            className="chat-widget-minimize-button"
            onClick={toggleChat}
            aria-label="Minimize chat" // Changed label from "Close"
            title="Minimize chat"
          >
            {/* Use direct import */}
            <FaChevronDown size={18} />
          </button>
        </div>
        <div className="chat-widget-content">
          {/* Iframe is always rendered now, preserving its state */}
          <iframe
            src={chatUrl}
            className="chat-widget-iframe"
            title="Chat Application"
            frameBorder="0"
          />
        </div>
      </div>
    </>
  );
}

export default ChatWidget;
